import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
export const BillingNameTitle = ({
  billingNameKey
}) => {
  const i18nKey = `pricing-pages-ui.productNamesV2.${billingNameKey}.title`;
  if (!isValidI18nKey(i18nKey)) return null;
  return /*#__PURE__*/_jsx(FormattedMessage, {
    "data-test-id": "billing-name-title",
    message: i18nKey
  });
};